module.exports = __webpack_public_path__ + "img/52e7483.svg";